/**
 * Badkern Garantie-Upsell „Pure Sicherheit“ – Logik als Asset (09.10.2026).
 * Vorher stand das Skript im Snippet; nach einem Section-Morph des Drawers (z. B. erstes
 * Hinzufügen aus leerem Warenkorb) führt der Browser eingefügte Skripte nicht aus, der
 * Kauf-Button schickte dann das Formular klassisch ab und wechselte zur Warenkorbseite.
 * Als Asset ist die Logik immer da; alle Handler sind delegiert.
 */
import { sectionRenderer } from '@theme/section-renderer';

if (!window.__bkGups) {
  window.__bkGups = true;
  let laeuft = false;
  let fehlschlaege = 0;

  async function post(url, body) {
    const r = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    if (!r.ok) throw new Error(url + ' ' + r.status);
    return r.json();
  }

  async function neuRendern(el) {
    const sid = el && el.dataset.gupsSection;
    if (!sid) { location.reload(); return; }
    await sectionRenderer.renderSection(sid, { cache: false, mode: sid === 'cart-drawer-section' ? 'hydration' : 'full' });
  }

  // Falsche Stufe im Korb → tauschen; Garantie ohne Produkt oder ab 5.000 € → entfernen
  async function pruefen() {
    if (laeuft || fehlschlaege >= 2) return;
    const el = document.querySelector('[data-gups]');
    if (!el) return;
    const tauschen = el.querySelector('[data-gups-tauschen]');
    const entfernen = el.querySelector('[data-gups-entfernen]');
    if (!tauschen && !entfernen) return;
    laeuft = true;
    try {
      if (el.dataset.gupsKey) await post('/cart/change.js', { id: el.dataset.gupsKey, quantity: 0 });
      if (tauschen && el.dataset.gupsSoll) await post('/cart/add.js', { items: [{ id: Number(el.dataset.gupsSoll), quantity: 1 }] });
      fehlschlaege = 0;
      await neuRendern(el);
    } catch (e) {
      fehlschlaege += 1;
      console.warn('[pure-sicherheit]', e);
    } finally {
      laeuft = false;
    }
  }

  // Kasten (Warenkorbseite): Kauf-Button per fetch, damit die Seite nicht wegnavigiert
  document.addEventListener('submit', async (ev) => {
    const f = ev.target instanceof Element ? ev.target.closest('.gups__form') : null;
    if (!f) return;
    ev.preventDefault();
    const el = f.closest('[data-gups]');
    const knopf = f.querySelector('button');
    if (knopf) knopf.disabled = true;
    try {
      await post('/cart/add.js', { items: [{ id: Number(f.querySelector('[name=id]').value), quantity: 1 }] });
      await neuRendern(el);
    } catch (e) {
      console.warn('[pure-sicherheit]', e);
      if (knopf) knopf.disabled = false;
      f.submit();
    }
  });

  // Zeile (Drawer-Fußzeile): Checkbox an = Garantie hinzufügen, aus = entfernen
  document.addEventListener('change', async (ev) => {
    const box = ev.target instanceof Element ? ev.target.closest('[data-gups-toggle]') : null;
    if (!box) return;
    const el = box.closest('[data-gups]');
    if (!el || laeuft) return;
    laeuft = true;
    box.disabled = true;
    try {
      if (box.checked) {
        if (el.dataset.gupsKey) await post('/cart/change.js', { id: el.dataset.gupsKey, quantity: 0 });
        if (el.dataset.gupsSoll) await post('/cart/add.js', { items: [{ id: Number(el.dataset.gupsSoll), quantity: 1 }] });
      } else if (el.dataset.gupsKey) {
        await post('/cart/change.js', { id: el.dataset.gupsKey, quantity: 0 });
      }
      fehlschlaege = 0;
      await neuRendern(el);
    } catch (e) {
      console.warn('[pure-sicherheit]', e);
      box.checked = !box.checked;
      box.disabled = false;
    } finally {
      laeuft = false;
    }
  });

  new MutationObserver(() => { pruefen(); }).observe(document.documentElement, { childList: true, subtree: true });
  pruefen();
}
